import {IconProps} from "./types";

export const NoteIcon = (props: IconProps) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 2C11.3135 2 14 4.68645 14 8C14 11.3135 11.3135 14 8 14C7.22996 14 6.4925 13.8542 5.81445 13.5889C5.66556 13.5306 5.52811 13.5149 5.41309 13.5342L3.11523 13.9219C2.50531 14.0243 1.97566 13.4947 2.07812 12.8848L2.46582 10.5869C2.48509 10.4719 2.46941 10.3344 2.41113 10.1855C2.1458 9.5075 2 8.77004 2 8C2 4.68645 4.68645 2 8 2ZM5.33301 8.66699C4.96497 8.66717 4.66602 8.9659 4.66602 9.33398C4.66637 9.70177 4.96518 9.99983 5.33301 10H8C8.36782 9.99982 8.66566 9.70177 8.66602 9.33398C8.66602 8.9659 8.36804 8.66717 8 8.66699H5.33301ZM5.33301 6C4.96497 6.00017 4.66602 6.29891 4.66602 6.66699C4.66619 7.03493 4.96507 7.33381 5.33301 7.33398H10.666C11.0341 7.33398 11.3328 7.03503 11.333 6.66699C11.333 6.2988 11.0342 6 10.666 6H5.33301Z"
        fill={props.fill || "#9CA3AF"}
      />
    </svg>
  );
};
